import { json } from "@sveltejs/kit";
import { h as handleRequest } from "../../../../../../chunks/utils2.js";
import "firebase-admin";
import { U as UserCollection } from "../../../../../../chunks/firebase.js";
const ensureUserId = async (userDoc) => {
  const user = userDoc.data();
  if (userDoc.id.includes("@glimmr.com")) {
    await userDoc.ref.delete();
    await UserCollection().doc(user.id).set(user);
  }
};
const GET = handleRequest(async () => {
  const users = await UserCollection().get();
  const promises = users.docs.map(ensureUserId);
  await Promise.all(promises);
  return json({
    success: true
  });
});
export {
  GET
};
